import { AvvirEvent } from "type_aliases";

export type AutoVerifyRanEvent = AvvirEvent<typeof AUTO_VERIFY_RAN, {
  floorId: string,
  scanDatasetId: string,
}>

const autoVerifyRan = (floorId: string, scanDatasetId: string): AutoVerifyRanEvent => ({
  type: AUTO_VERIFY_RAN,
  payload: {
    floorId,
    scanDatasetId,
  },
});

export const AUTO_VERIFY_RAN = "auto_verify_ran";

export default autoVerifyRan;
